// extracted by mini-css-extract-plugin
export var container = "styles-module--container--c7dd2";
export var marquee = "styles-module--marquee--5e88b";
export var marqueeLeft = "styles-module--marquee-left--86734";
export var marqueeRight = "styles-module--marquee-right--46201";
export var marqueeRow = "styles-module--marqueeRow--5c724";
export var marqueeRowText = "styles-module--marqueeRowText--4aac1";
export var marqueeRowTextLeft = "styles-module--marqueeRowTextLeft--7aa0e";
export var marqueeRowTextRight = "styles-module--marqueeRowTextRight--c496d";